import React, { useContext, useEffect, useState } from "react";

import AuthContext from "../../context/AuthContext";

import "./MainSection.css";
import Container from "../../components/ui/Container";

import OffsetButton from "../../components/ui/Buttons/OffsetButton";

import kometHeroImg from "../../assets/komet-assets/mainSectionHero.png";

import { ReactComponent as QuranIcon } from "../../assets/telawah-assets/quranIconBtn.svg";
import Pattern from "../../assets/telawah-assets/heroBgPattern.svg";
import "./Heroimage.css";

import { ReactComponent as TextDecore } from "../../assets/monqez-assets/scratch.svg";
import { useLanguage } from "../../context/LanguageContext";
const MainSection = ({ title = "", id = 0 }) => {
    const { language } = useLanguage();
    const content = {
        SectionHeaderTitle: {
            en: {
                prefix: "Your Choice for Learning German",
                highlight: "Practically",
            },
            de: {
                prefix: "Ihre Wahl zum Deutschlernen",
                highlight: "Praxisnah",
            },
            ar: {
                prefix: "إختيارك لتعلّم اللغة الألمانية",
                highlight: "بطريقة عملية",
            },
        },
        subSectionHeaderTitle: {
            en: 'If you want to speak German fluently, "Komet" is your ideal destination. We are a comprehensive institute specializing in providing the best services for learning German easily and professionally.',
            de: '"Komet" ist Ihre perfekte Wahl, um Deutsch einfach und professionell zu lernen und fließend zu sprechen.',
            ar: 'إذا كنت تريد التحدث بالألمانية بطلاقة، فإن "كوميت" هو وجهتك المثالية. نحن معهد متكامل متخصص في تقديم أفضل الخدمات لتعلّم اللغة الألمانية بسهولة واحترافية..',
        },
        cta: {
            en: 'Join "Komet" now and start your journey to mastering the German language!',
            de: 'Werden Sie Teil von "Komet" und meistern Sie Deutsch!',
            ar: 'انضم إلى "كوميت"  الآن وابدأ رحلتك نحو إتقان اللغة!',
        },
        button: {
            subscribe: {
                en: "Your Journey to Development",
                de: "Bei uns registrieren",
                ar: "رحلتك إلى لتطوير",
            },
            myCourses: {
                en: "My Courses",
                de: "Meine Kurse",
                ar: "كورساتي",
            },
        },
    };
    const { token } = useContext(AuthContext);

    return (
        <>
            <section className="md:h-screen min-h-screen negative-nav-margin relative overflow-hidden">
                {/* <div
                    className="right-0 top-0 bottom-0 h-full w-full z-0 absolute opacity-80 dark:opacity-20 smooth"
                    style={{
                        backgroundImage: "url(" + Pattern + ")",
                        backgroundSize: "contain",
                        backgroundPosition: "center center",
                        backgroundRepeat: "repeat-both",
                    }}
                ></div> */}
                <Container className="h-full relative z-10  pt-32 md:pt-0 pb-20 md:pb-0">
                    <div
                        className={`w-full flex ${
                            language !== "ar" ? "md:flex-row rtl" : "md:flex-row-reverse"
                        }   flex-col h-full space-y-10 md:space-y-0 `}
                    >
                        <div className="md:basis-1/2 px-0 md:px-10 basis-full h-full flex-center-both">
                            <div
                                className={`flex md:items-start items-center justify-center flex-col space-y-6 md:space-y-0 ${
                                    language !== "ar" ? "en" : "ar"
                                }`}
                            >
                                <div className="relative">
                                    <div className="relative z-10 ">
                                        <div className="pt-3">
                                            <h1
                                                className={`text-3xl relative w-full px-4 md:px-0 mx-auto sm:mx-0 md:w-[66%] lg:text-4xl clr-text-primary smooth text-center ${
                                                    language !== "ar"
                                                        ? "md:text-left"
                                                        : "md:text-right"
                                                }`}
                                            >
                                                <span className={`text-accentBlue font-w-bold`}>
                                                    {content.SectionHeaderTitle[language].prefix}{" "}
                                                    <span className="text-germanRed-700">
                                                        {
                                                            content.SectionHeaderTitle[language]
                                                                .highlight
                                                        }
                                                    </span>
                                                </span>
                                            </h1>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className={`pt-6 text-center ${
                                        language !== "ar" ? "md:text-left" : "md:text-right"
                                    }  text-lg md:text-xl w-3/4  text-gray-500 dark:text-gray-200 smooth space-y-2 flex-center-both flex-col `}
                                >
                                    {content.subSectionHeaderTitle[language]}
                                </div>
                                <div
                                    className={`pt-6 text-center ${
                                        language !== "ar" ? "md:text-left" : "md:text-right"
                                    }  text-lg md:text-xl w-3/4  text-gray-500 dark:text-gray-200 smooth space-y-2 flex-col `}
                                >
                                    {content.cta[language]}
                                </div>

                                <div className=" pt-12 md:pt-20 relative md:pb-0 w-fit  ">
                                    <OffsetButton
                                        type="default"
                                        color="germanRed"
                                        className="flex-center-both z-10 scale text-lg gap-4"
                                        to={!token ? `/register` : "/me/user/courses"}
                                    >
                                        {!token
                                            ? content.button.subscribe[language]
                                            : content.button.myCourses[language]}
                                    </OffsetButton>
                                    <div className="absolute top-12 right-10 blur-sm opacity-80">
                                        <span className="text-stroke  font-extrabold text-[80px] text-transparent">
                                            KOMET
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="md:basis-1/2 basis-full h-full flex-center-both pt-10 md:pt-0">
                            <div className="flex-center-both max-w-2xl px-4 sm:px-20">
                                <img src={kometHeroImg} alt={"profile"} className="" />
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
        </>
    );
};

export default MainSection;
